import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import * as Icon from "react-feather";
import TextareaAutosize from 'react-autosize-textarea';
import Loader from 'react-loader-spinner'
import {DataRegister} from "../../services/DataRegister";

class ContactForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            phone: "",
            note: "",
            loading: false,
            success: false
        };
    };

    componentWillMount() {}

    componentDidMount() {}

    _send(){
        if(this.state.email !== "" && this.state.phone !== "" && this.state.note !== ""){
            this.setState({loading: true, success: false, error: false});
            DataRegister.setMessage(this.state.email, this.state.phone, this.state.note).then((response) => {
                setTimeout(() => {
                    this.setState({loading: false, phone: "", note: "", email: "", success: true});
                }, 500);
            }, (error) => {
                this.setState({loading: false, phone: "", note: "", email: ""});
            });
        }else{
            this.setState({success: false, error: true});
        }
    }

    _goInternal(option){
        window.open(option, '_self');
    }

    render() {
        return (
            <div className={Styles.sectionFour}>
                <div className={Styles.sectionFourInner}>
                    <div className={Styles.sectionFourInnerBoxLeft}>
                        <div className={Styles.sectionFourInnerBoxLeftContent}>
                            <div className={Styles.sectionFourInnerBoxLeftContentTitle}>
                                WHATSAPP US!
                            </div>
                            <img onClick={() => this._goInternal("whatsapp://send?text=Hey Swedish Tech Mafia...&phone=+971543429986")} className={Styles.sectionFourInnerBoxLeftContentTitleIcon} src={require("../../assets/images/STM_social_whatsapp_Black.png")}/>
                            <div className={Styles.sectionFourInnerBoxRightContentFormButton}>
                                <div onClick={() => this._goInternal("whatsapp://send?text=Hey Swedish Tech Mafia...&phone=+971543429986")} className={Styles.sectionFourInnerBoxRightContentFormButtonInner}>
                                    <div className={Styles.sectionFourInnerBoxRightContentFormButtonInnerItem}>
                                        <span className={Styles.sectionFourInnerBoxRightContentFormButtonInnerItemMobile}>Chat</span>
                                        <span className={Styles.sectionFourInnerBoxRightContentFormButtonInnerItemDesktop}>+971543429986</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.sectionFourInnerBoxRight}>
                        <div className={Styles.sectionFourInnerBoxRightContent}>
                            <div className={Styles.sectionFourInnerBoxRightContentTitle}>
                                message us!
                            </div>
                            <div className={Styles.sectionFourInnerBoxRightContentForm}>
                                <form action="https://formspree.io/swedishtechmafia@icloud.com" method="POST">
                                    <div className={
                                        cx(Styles.sectionFourInnerBoxRightContentFormInput,
                                            {
                                                [Styles.sectionFourInnerBoxRightContentFormError]: this.state.error && this.state.email === "",
                                            })
                                    }>
                                        <input value={this.state.email}
                                               onChange={(event) => {
                                                   this.setState({email: event.target.value})
                                               }}
                                               placeholder={"Email"}
                                               type="email"
                                               className={Styles.sectionFourInnerBoxRightContentFormInputItem}/>
                                    </div>
                                    <div className={
                                        cx(Styles.sectionFourInnerBoxRightContentFormInput,
                                            {
                                                [Styles.sectionFourInnerBoxRightContentFormError]: this.state.error && this.state.phone === "",
                                            })
                                    }>
                                        <input value={this.state.phone}
                                               onChange={(event) => {
                                                   this.setState({phone: event.target.value})
                                               }}
                                               placeholder={"Phone"}
                                               type="tel"
                                               pattern="[0-9]*"
                                               className={Styles.sectionFourInnerBoxRightContentFormInputItem}/>
                                    </div>
                                    <div className={
                                        cx(Styles.sectionFourInnerBoxRightContentFormTextArea,
                                            {
                                                [Styles.sectionFourInnerBoxRightContentFormError]: this.state.error && this.state.note === "",
                                            })
                                    }>
                                        <TextareaAutosize
                                            value={this.state.note}
                                            onChange={(event) => {
                                                this.setState({note: event.target.value})
                                            }}
                                            placeholder={"Message"}
                                            type="text"
                                            className={Styles.sectionFourInnerBoxRightContentFormTextAreaItem}
                                        />
                                    </div>
                                    <div className={Styles.sectionFourInnerBoxRightContentFormButton}>
                                        <div onClick={() => this._send()} className={Styles.sectionFourInnerBoxRightContentFormButtonInner}>
                                            {
                                                !this.state.loading && !this.state.success &&
                                                <div className={Styles.sectionFourInnerBoxRightContentFormButtonInnerItem}>
                                                    Send
                                                </div>
                                            }
                                            {
                                                this.state.success &&
                                                <div className={cx(Styles.sectionFourInnerBoxRightContentFormButtonInnerItem, Styles.sectionFourInnerBoxRightContentFormButtonInnerItemSuccess)}>
                                                    Thanks!
                                                </div>
                                            }
                                            {
                                                this.state.loading && !this.state.success &&
                                                <div className={Styles.sectionFourInnerBoxRightContentFormButtonInnerItem}>
                                                    <Loader
                                                        type="ThreeDots"
                                                        color="#ffffff"
                                                        height="70"
                                                        width="70"
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/contact-form/component.js